import type { FaqItem } from "@/types/news";

interface FaqListProps {
  items: FaqItem[];
  columns?: 1 | 2;
}

export default function FaqList({ items, columns = 2 }: FaqListProps) {
  return (
    <div
      className={`grid grid-cols-1 gap-4 ${columns === 2 ? "md:grid-cols-2" : ""}`}
    >
      {items.map((item) => (
        <article
          key={item.q}
          className="rounded-lg border border-background-200 bg-background-50 p-5"
        >
          <h3 className="flex items-start gap-2.5 font-heading text-base font-semibold text-foreground-950">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-bold text-primary-700">
              Q
            </span>
            {item.q}
          </h3>
          <p className="mt-3 pl-9 text-sm leading-relaxed text-foreground-600">{item.a}</p>
        </article>
      ))}
    </div>
  );
}